// Сортирует "натуральной" сортировкой, доступной в самом JS через localeCompare
// https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare
import '@shared/types-v0.1.0'

export default function (originalArray: any[] = [], sortPath: string = '', direction: 'asc' | 'desc' = 'asc') {
	const { get } = R.libs.just

	// Создает функцию для сравнения. Рекомендованор в документации для больших массивов. В даном случае:
	// 1. Учитывает, что слова могут быть русские или английские.
	// 2. Сортирует номера привычным для человека образом.
	// 3. Игнорирует регистр.
	// 4. Обрезаются пробелы методом trim()

	const compare = new Intl.Collator(['ru', 'en'], { numeric: true, sensitivity: 'base' }).compare

	// Безопасно берем строку по пути
	const getValue = (obj: any, path: string) => String(get(obj, path) || '').trim()

	// Для .sort нужен клон, но не глубокий, чтобы не убивать прокси.
	// Учитываем направление, меняя местами a и b.
	return [...originalArray].sort((a, b) =>
		compare(getValue(direction === 'asc' ? a : b, sortPath), getValue(direction === 'asc' ? b : a, sortPath))
	)
}
